import { render, staticRenderFns } from "./link-expired.vue?vue&type=template&id=ccaf37ca&scoped=true"
import script from "./link-expired.vue?vue&type=script&lang=js"
export * from "./link-expired.vue?vue&type=script&lang=js"
import style0 from "./link-expired.vue?vue&type=style&index=0&id=ccaf37ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccaf37ca",
  null
  
)

export default component.exports